import gql from 'graphql-tag';
const A_PARAGRAPH_WPM_ACTIVITY_FRAGMENT = gql `
  fragment AParagraphWpmActivityFragment on AParagraphWpmActivity {
    rounds {
      paragraph
    }
  }
`;
export default A_PARAGRAPH_WPM_ACTIVITY_FRAGMENT;
